import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { elevation, typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'
import mediaQuery from '@mathflat/common/style/mediaQuery'

const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    > .accordion-wrap {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .search-wrapper {
      display: flex;
      border-right: 1px solid ${colors.gray.$400};
      border-left: 1px solid ${colors.gray.$400};
      padding: 10px;
      background-color: white;
    }
  `,

  accordion: css`
    flex: auto;
    height: 0;
    border: 1px solid ${colors.gray.$400};
    border-radius: 0 0 var(--Radius-200) var(--Radius-200);
    .empty-student-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: ${colors.gray.$700};
      ${typo.body02}
      text-align: center;
    }
  `,
  itemContent: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    background-color: white;

    > * {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 56px;
      padding-left: 38px;
      padding-right: 15.5px;
      border-bottom: 1px solid ${colors.gray.$200};
      visibility: hidden;
      transition: visibility 0.28s;
      cursor: pointer;

      &:first-of-type {
        border-top: 1px solid ${colors.gray.$200};
      }

      &:last-child {
        border: none;
      }

      .clicked {
        color: var(--Colors-Green-500);
        font-weight: 700;

        > svg > path {
          fill: var(--Colors-Green-500);
        }
      }

      > div {
        display: flex;

        .people {
          margin-left: 7px;
        }
      }

      button {
        ${typo.caption01}
      }
    }
  `,
  itemContentOpen: css`
    > * {
      visibility: visible;
    }
  `,
  tab: css`
    display: flex;
    height: 40px;
  `,
  label: css`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100%;
    border: 1px solid ${colors.borderColor};
    background-color: ${colors.gray.$100};
    color: ${colors.gray.$600};
    cursor: pointer;
    & + li {
      border-left: none;
    }
    &.active {
      border-bottom: none;
      background-color: white;
      color: ${colors.gray.$900};
    }
  `,
  lessonStudentGroup: css`
    flex: 1;
  `,
  accordionWrap: css`
    display: flex;
    position: relative;
    flex: 0 0 198px;
    flex-direction: column;
    height: 100%;
    margin-right: 16px;
    transition: all 0.3s ease-in-out;

    &.floated {
      flex: 0;
    }

    .lesson-accordion-container {
      position: absolute;
      top: 0;
      left: 0;
      min-width: 198px;
      height: 100%;
      overflow: hidden;
      transition: box-shadow 0s 0s;

      z-index: 19;
    }

    .lesson-accordion-contents {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      visibility: visible;
      transition: all 0.3s ease-in-out;
      transform: translateX(0);
    }

    &.floated {
      display: flex;
      width: 0;
      flex: 0 0 0px;
      margin-right: 0;
      .accordion-header {
        background: #fff;
      }

      .lesson-accordion-container {
        width: 238px;
        visibility: hidden;
        box-shadow:
          0px 4px 8px rgba(41, 42, 43, 0),
          0px 12px 16px rgba(41, 42, 43, 0);
      }

      .lesson-accordion-contents {
        visibility: hidden;
        transform: translateX(-100%);
        z-index: 10;
      }

      &.open {
        .lesson-accordion-container {
          visibility: visible;
          transition: box-shadow 0.22s 0.22s;
          ${elevation.$02};
        }

        .lesson-accordion-contents {
          width: 100%;
          visibility: visible;
          transform: translateX(0);
        }
      }
    }

    ${mediaQuery.large} {
      &.floatable {
        display: flex;
        width: 0;
        flex: 0 0 0px;
        margin-right: 0;

        .lesson-accordion-container {
          width: 198px;
          visibility: hidden;
          box-shadow:
            0px 4px 8px rgba(41, 42, 43, 0),
            0px 12px 16px rgba(41, 42, 43, 0);
        }

        .lesson-accordion-contents {
          visibility: hidden;
          transform: translateX(-100%);
          z-index: 10;
        }

        &.open {
          .lesson-accordion-container {
            visibility: visible;
            transition: box-shadow 0.22s 0.22s;
            ${elevation.$02};
          }

          .lesson-accordion-contents {
            width: 100%;
            visibility: visible;
            transform: translateX(0);
          }
        }
      }
    }
  `,
  accordionOpenButton: css`
    position: absolute;
    display: none;
    align-items: center;
    width: 112px;
    height: 28px;
    padding: 0 12px;
    border-radius: var(--Radius-300);
    background-color: var(--Colors-Gray-100);

    &.floated {
      display: flex;
    }

    ${mediaQuery.large} {
      display: flex;
    }

    .student-state {
      min-width: 7px;
      height: 7px;
      border-radius: var(--Radius-Circle);
      background-color: ${colors.gray.$400};

      &.enter {
        background-color: var(--Colors-Green-500);
      }

      &.quit {
        background-color: ${colors.gray.$800};
      }
    }

    .chevron_double_right {
      margin-left: auto;
      min-width: 10px;

      &.show {
        transform: rotate(180deg);
      }
    }

    .button-label {
      display: flex;

      p {
        ${typo.caption01}
        margin: 0 6px;
        margin-top: 2px;
        color: ${colors.gray.$800};
      }
    }
  `,
  groupItem: css`
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: 0 16px;
    height: 48px;
    width: 100%;

    border-bottom: 1px solid ${colors.gray.$200};
    background-color: ${colors.gray.$100};

    .group-name {
      color: ${colors.gray.$900};
    }

    .group-count {
      margin-left: auto;
      color: ${colors.gray.$700};
      ${typo.caption01};
    }

    .group-arrow {
      margin-right: 2px;
    }
  `,
  accordionFilter: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px 10px;
    width: 100%;
    border-left: 1px solid ${colors.gray.$400};
    border-right: 1px solid ${colors.gray.$400};
    background-color: white;
  `,
  accordionHeader: css`
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.gray.$400};
    border-right: 1px solid ${colors.gray.$400};
    border-left: 1px solid ${colors.gray.$400};
    border-radius: var(--Radius-200) var(--Radius-200) 0 0;
    background-color: white;
    gap: 8px;
    padding: 16px 0;
    ${mediaQuery.large} {
      padding: 10px 12px;
      background-color: #fff;
    }
  `,
  studentMember: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 0 40px;
    height: 56px;
    width: 100%;
    border-bottom: 1px solid ${colors.gray.$200};
    background-color: white;

    .icon-people {
      margin-left: 8px;
      margin-right: auto;
    }

    .attendance-button {
      ${typo.caption01};
    }

    &.active {
      color: var(--Colors-Green-500);
      font-weight: 700;

      svg path {
        fill: var(--Colors-Green-500);
      }
    }
  `,
}

export default S
